document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded");

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach(function (node) {
          // Check if the added node is a checkbox or contains checkboxes
          if (node.nodeType === 1) {
            // Element node
            var checkboxes = node.querySelectorAll(".ppa-prod-checkbox-left");
            if (checkboxes.length > 0) {
              setupCheckboxes(checkboxes);
            }
          }
        });
      }
    });
  });

  // Configuration of the observer:
  var config = { childList: true, subtree: true };

  // Pass in the target node, as well as the observer options
  observer.observe(document.body, config);

  function setupCheckboxes(checkboxes) {
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var prodContainer = this.closest(".ppa-prod-container");

        if (this.checked) {
          prodContainer.classList.add("selected");
        } else {
          prodContainer.classList.remove("selected");
        }
      });
    });
  }
});
